import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IOption } from '../../controls/models/option';

@Component({
    selector: 'app-select-multiple-committee-status',
    templateUrl: './select-multiple-committee-status.component.html',
    styleUrl: './select-multiple-committee-status.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectMultipleCommitteeStatusComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectMultipleCommitteeStatusComponent implements ControlValueAccessor {

  @Input() id: string = 'select-committee-status';
  @Input() label: string = 'Committee Status';

  onChange: any = () => { };
  onTouched: any = () => { };

  private _values: any[] | undefined;
  get values() {
    return this._values;
  }
  set values(values) {
    this._values = values;
    this.onChange(values);
    this.onTouched();
  }

  options: IOption<string>[] = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
  ];

  constructor(
  ) {

  }

  writeValue(values: any[]): void {
    this.values = values;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}